import { useState, useEffect, useCallback } from "react";
import { FlattenedObject, Pos } from "../models/Po";
import { flattenPoData, sortFlattenedObject } from "../utils/utils";
import { getMatchingRecipeIds, Recipe } from "../utils/recipeFinder";
import apiAxios from "../utils/apiAxios";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { appendAlert } from "../redux/alertSlice";
import { setShouldFetch } from "../redux/shouldFetchSlice";
import { setCheckedRowUpdateAt } from "../redux/procGridSlice";

import { QueryParams } from "../models/Po";

const useFetchData = (
  apiUrl: string,
  queryParams: QueryParams,
  holidays: string[]
) => {
  const shouldFetch = useSelector(
    (state: RootState) => state.shouldFetch.value
  );
  const dispatch = useDispatch();

  const [rowData, setRowData] = useState<FlattenedObject[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const toQueryString = (params: QueryParams) => {
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlParams.append(key, String(value));
      }
    });
    return urlParams.toString();
  };

  const fetchData = useCallback(async () => {
    if (shouldFetch) {
      setIsLoading(true);
      const queryString = toQueryString(queryParams);

      console.log(`${apiUrl}?${queryString}`);
      if (queryString === "") {
        return;
      }

      try {
        const response = await apiAxios.get<Pos>(`${apiUrl}?${queryString}`);
        const data = response.data;

        if (data !== null) {
          let flattenedData = flattenPoData(data, holidays);
          // recipe_idの列を追加
          flattenedData = flattenedData.map((item) => {
            const matchingRecipes: Recipe[] = getMatchingRecipeIds(item);
            if (matchingRecipes.length > 0) {
              return {
                ...item,
                recipe_id: matchingRecipes[0].recipe_id, // 一つ目のマッチするrecipe_idを選びます
                recipe_name: matchingRecipes[0].recipe_name,
                tempering_cycle_time: matchingRecipes[0].cycle_tile,
                evaluate_fn_string: matchingRecipes[0].evaluateFn.toString(),
              };
            }
            return item; // recipe_idが見つからなかった場合、元の項目をそのまま返します
          });

          // ソートする
          const sortedData = sortFlattenedObject(flattenedData);

          setRowData(sortedData);
        } else {
          setRowData([]);
        }
        setIsLoading(false);
        dispatch(setShouldFetch(false)); // Redux Action
        // チェック状態の更新日時を更新
        dispatch(setCheckedRowUpdateAt(new Date().toISOString()));
      } catch (error: any) {
        setIsLoading(false);
        dispatch(
          appendAlert({
            severity: "error",
            message: "データの取得に失敗しました。" + error.message,
            displayTime: 5000,
          })
        );
        console.error("Failed to fetch:", error);
      }
    }
  }, [apiUrl, queryParams, holidays, shouldFetch, dispatch]);

  useEffect(() => {
    if (shouldFetch) {
      fetchData();
    }
  }, [fetchData, queryParams, shouldFetch]);

  return { rowData, isLoading, fetchData };
};

export default useFetchData;
